import { FC } from "react";

import { Collapse, Stack } from "@mui/material";
import { useController, UseFormReturn } from "react-hook-form";

import { StepSuggestedDonationAmountsFormData } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardIcon } from "@/dashboard-design-system/Icon";
import { DashboardSwitch } from "@/dashboard-design-system/Switch/DashboardSwitch";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { Sparks } from "@/icons/outlined";

interface SmartAmountsBlockProps {
  form: UseFormReturn<StepSuggestedDonationAmountsFormData>;
}

export const SmartAmountsBlock: FC<SmartAmountsBlockProps> = ({ form }) => {
  const { t } = useTranslate();
  const { field } = useController({ name: "smartAmountsEnabled", control: form.control });

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <DashboardIcon size="large" vibe="text-brand-moderate" sx={{ display: "flex", flexShrink: 0 }}>
            <Sparks />
          </DashboardIcon>
          <DashboardTypography variant="subtitle1" vibe="text-brand-intense">
            {t("dashboard", "liveFormEditor.stepSuggestedDonationAmounts.smartAmountsTitle")}
          </DashboardTypography>
        </Stack>
        <DashboardSwitch
          name="smartAmountsEnabled"
          checked={field.value}
          onChange={(_, checked) => field.onChange(checked)}
          data-test="smart-amounts-switch"
          sx={{ flexShrink: 0 }}
        />
      </Stack>
      <Collapse in={field.value} timeout="auto">
        <DashboardTypography variant="caption" vibe="text-brand-moderate">
          {t("dashboard", "liveFormEditor.stepSuggestedDonationAmounts.smartAmountsDescription")}
        </DashboardTypography>
      </Collapse>
    </Stack>
  );
};
